if (typeof BundleProducts !== "function") {
	class BundleProducts extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			// 1) boutons +/-
			document
				.querySelectorAll(".bundle button[data-action]")
				.forEach((btn) =>
					btn.addEventListener("click", this._onQtyButtonClick.bind(this))
				);

			document
				.querySelectorAll("input[type='number']")
				.forEach((input) =>
					input.addEventListener("change", this._updateBundleTotal.bind(this))
				);

			// 3) calcul initial
			this._updateBundleTotal();

			// 2) écoute du changement de variante principale
			this.prodVariantsEl = document.querySelector("product-variants");
			if (this.prodVariantsEl) {
				this.prodVariantsEl.addEventListener("VARIANT_CHANGE", () => {
					this._updateBundleTotal();
				});
				this.prodVariantsEl.updatePriceOnATC();
			}
		}

		_onQtyButtonClick(event) {
			const btn = event.currentTarget;
			const action = btn.dataset.action; // "plus" ou "minus"
			const targetId = btn.dataset.target; // ex. "qty-12345"
			const input = this.querySelector(`#${targetId}`);
			if (!input) return;

			// incrémente / décrémente
			let qty = parseInt(input.value, 10) || 0;
			action === "plus" ? qty++ : qty > 0 && qty--;
			input.value = qty;

			// active / désactive le bouton –
			const minusBtn = this.querySelector(
				`button[data-action="minus"][data-target="${targetId}"]`
			);
			if (minusBtn) minusBtn.disabled = qty <= 0;

			// re-calcul
			this._updateBundleTotal();
		}

		_updateBundleTotal() {
			// — 1) montant brut du bundle
			let upsellCents = 0;
			let upsellRegularCents = 0; // Prix régulier des upsells
			window.totalQty = 0;
			document
				.querySelectorAll(".bundle-wrapper-upsells .bundle-item")
				.forEach((item) => {
					const qty = parseInt(item.querySelector("input").value, 10) || 0;
					const unitPrice = parseInt(item.dataset.unitPrice, 10) || 0;
					window.totalQty += qty;
					upsellCents += unitPrice * qty;
					upsellRegularCents += unitPrice * qty; // Prix régulier = prix unitaire
				});

			let crossCents = 0;
			let crossRegularCents = 0; // Prix régulier des cross-sells
			document
				.querySelectorAll(".bundle-wrapper-cross-sells .bundle-item")
				.forEach((item) => {
					const qty = parseInt(item.querySelector("input").value, 10) || 0;
					const unitPrice = parseInt(item.dataset.unitPrice, 10) || 0;
					crossCents += unitPrice * qty;
					crossRegularCents += unitPrice * qty; // Prix régulier = prix unitaire
				});

			// — 2) mise à jour des steps
			const progress = document.querySelector(".progress-bundle");
			if (progress) {
				const isFollowing =
					progress.dataset.isFollowing === "true" ? true : false;
				const steps = Array.from(progress.querySelectorAll(".progress-step"));
				steps.forEach((step) => {
					const min = parseInt(step.dataset.min, 10) || 0;
					const hasMax = step.hasAttribute("data-max");
					const max = hasMax ? parseInt(step.dataset.max, 10) : Infinity;
					const isLast = !hasMax;

					const drag = step.querySelector(".progress-step-drag");

					if (isLast) {
						if (totalQty >= min) {
							step.classList.add("active");
							step.classList.remove("current");
							if (isFollowing) drag.style.width = "100%";
						} else {
							step.classList.remove("active", "current");
							if (isFollowing) drag.style.width = "0%";
						}
					} else {
						const rawPct = (totalQty + 1 - min) / (max - min);
						const pct = Math.max(0, Math.min(rawPct, 1)) * 100;
						const width = `${pct}%`;

						if (totalQty >= max) {
							step.classList.add("active");
							step.classList.remove("current");
							if (isFollowing) drag.style.width = "100%";
						} else if (totalQty >= min) {
							step.classList.add("current");
							step.classList.remove("active");
							if (isFollowing) drag.style.width = width;
						} else {
							step.classList.remove("current", "active");
							if (isFollowing) drag.style.width = "0%";
						}
					}
				});
			}

			// — 3) application éventuelle de la réduction
			let reducStep = document.querySelector(".progress-step.current");
			if (!reducStep) {
				const active = Array.from(
					document.querySelectorAll(".progress-step.active")
				);
				reducStep = active[active.length - 1];
			}
			
			// Calculer le prix régulier total avant réduction
			const totalRegularCents = upsellRegularCents + crossRegularCents;
			
			if (reducStep && reducStep.dataset.reduc) {
				const pct = parseFloat(reducStep.dataset.reduc) / 100;
				upsellCents = Math.round(upsellCents * (1 - pct));
			}

			const fmt = (cents) =>
				new Intl.NumberFormat("fr-FR", {
					style: "currency",
					currency: "EUR",
				}).format(cents / 100);

			const bundleQtySpan = document.querySelector("#bundle-qty");
			const bundlePriceSpan = document.querySelector("#bundle-price");
			const bundleRegularPriceSpan = document.querySelector("#bundle-regular-price");
			
			if (bundleQtySpan) bundleQtySpan.textContent = totalQty;
			if (bundlePriceSpan) bundlePriceSpan.textContent = fmt(upsellCents);
			
			// Afficher le prix régulier seulement s'il est différent du prix final
			if (bundleRegularPriceSpan) {
				const finalPrice = upsellCents + crossCents;
				if (totalRegularCents !== finalPrice) {
					bundleRegularPriceSpan.textContent = fmt(totalRegularCents);
					bundleRegularPriceSpan.style.display = "";
				} else {
					bundleRegularPriceSpan.style.display = "none";
				}
			}

			window.totalBundleCents = upsellCents + crossCents;

			if (this.prodVariantsEl) {
				this.prodVariantsEl.updatePriceOnATC();
			}
		}
	}

	if (typeof customElements.get("bundle-products") === "undefined") {
		customElements.define("bundle-products", BundleProducts);
	}
}